import React from "react";
import { Link } from "react-router-dom";

const CtaIcon = ({ btnText, state, icon, onClick, classes, to }) => {
  return (
    <Link
      to={to ? to : "#"}
      state={state ?? state}
      onClick={onClick ? onClick : console.log()}
      className={classes}
    >
      <span>{btnText}</span>
      <i className="ms-2">{icon}</i>
    </Link>
  );
};

export default CtaIcon;
